import React, { Component } from "react";
import { Form, Segment, Table, Select } from "semantic-ui-react";
import Page from "../../components/Page";
import _ from "lodash";
import { get } from "../../util/api";
import moment from "moment";
import { withTranslation } from "react-i18next";

class ActionTable extends Component {
  state = {
    loading: true,
    showTest: false,
    actionListHere: [],
    actionFilter: "all",
    ecommerceTypeFilter: "all",
    statusFilter: "all",
  };
  actionList = () => {
    get("/campaign/template/list").then((data) => {
      let response = _.map(data.data, (it, i) => {
        return it;
      });
      this.setState({ actionListHere: response });
    });
  };
  componentDidMount() {
    this.actionList();
    get("/campaign/report").then((data) => {
      this.setState({
        data: data.result,
        copieddata: data.result,
        loading: false,
      });
    });
  }

  applyFilters = (overrides = {}) => {
    const state = { ...this.state, ...overrides };
    let result = state.copieddata || [];
    if (!state.showTest) {
      result = _.filter(result, (it) => !/test/.test(it.email));
    }
    if (state.actionFilter !== "all") {
      result = _.filter(result, (it) => it.key === state.actionFilter);
    }
    if (state.ecommerceTypeFilter !== "all") {
      result = _.filter(result, (it) => it.type === state.ecommerceTypeFilter);
    }
    if (state.statusFilter !== "all") {
      result = _.filter(result, (it) => it.status === state.statusFilter);
    }
    this.setState({ data: result, ...overrides });
  };

  actionFilterr = (e, { value }) => {
    this.applyFilters({ actionFilter: value });
  };

  ecommerceTypeFilterr = (e, { value }) => {
    this.applyFilters({ ecommerceTypeFilter: value });
  };

  statusFilterr = (e, { value }) => {
    this.applyFilters({ statusFilter: value });
  };
  render() {
    let { data, loading, showTest, actionListHere, copieddata } = this.state;
    let { t } = this.props;
    if (loading) {
      return <Page.Loader></Page.Loader>;
    }
    let all = { value: "all", key: "all", text: t("all") };
    let actionDropwDown = [
      all,
      ..._.map(actionListHere, (it) => ({ value: it.id, key: it.id, text: it.title })),
    ];
    let ecommerceTypeOptions = [
      all,
      ..._.map(_.uniq(_.map(copieddata, "type")).filter(Boolean), (v) => ({ value: v, key: v, text: v })),
    ];
    let statusOptions = [
      all,
      ..._.map(_.uniq(_.map(copieddata, "status")).filter(Boolean), (v) => ({ value: v, key: v, text: v })),
    ];
    return (
      <Segment style={{ overflowY: "auto" }}>
        <Form>
          <Form.Checkbox
            label={t("TestMail")}
            name="showTest"
            checked={showTest}
            onClick={() => this.applyFilters({ showTest: !showTest })}
          ></Form.Checkbox>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Select
              width={6}
              placeholder={t("all")}
              options={actionDropwDown}
              onChange={this.actionFilterr}
            />
            <Select
              width={6}
              placeholder="Ecommerce Type"
              options={ecommerceTypeOptions}
              onChange={this.ecommerceTypeFilterr}
            />
            <Select
              width={6}
              placeholder="Status"
              options={statusOptions}
              onChange={this.statusFilterr}
            />
          </div>
        </Form>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={5}>Action</Table.HeaderCell>
              <Table.HeaderCell width={6}>Email</Table.HeaderCell>
              <Table.HeaderCell>Ecommerce Type</Table.HeaderCell>
              <Table.HeaderCell width={2}>Status</Table.HeaderCell>
              <Table.HeaderCell width={3}>Date</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {_.map(data, (it, i) => (
              <Table.Row>
                <Table.Cell>{it.title || it.key}</Table.Cell>
                <Table.Cell>{it.email}</Table.Cell>
                <Table.Cell>{it.type}</Table.Cell>
                <Table.Cell>{it.status}</Table.Cell>
                <Table.Cell>
                  {moment(it.date).format("DD-MM-YYYY HH:mm")}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default withTranslation()(ActionTable);
